import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/*
this.$router.go(-1);//返回上一层



*/

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index'),
    meta: {
      title: 'Home',
      keepAlive: false,
    }
  },
  {
    path: '/games',
    name: 'GAMES',
    component: () => import('@/views/games/index'),
    meta: {
      title: 'GAMES',
      keepAlive: true, // 此组件需要被缓存
    }
  },
  {
    path: '/newsDetail',
    name: 'NewsDetail',
    component: () => import('@/views/newDetail/index'),
    meta: {
      title: 'NewsDetail',
      keepAlive: false,
    }
  },
  {
    path: '/about',
    name: 'AboutUs',
    component: () => import('@/views/about/index'),
    meta: {
      title: 'AboutUs',
      keepAlive: false,
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/contact/index'),
    meta: {
      title: 'Contact',
      keepAlive: false,
    }
  },
]

const router = new VueRouter({
  routes,
  mode: 'hash',//history
})

export default router
